import { IntlShape } from 'react-intl';

export const dictionary = {
    event_button_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.sport.i18n.88d12381c62b72a9e0e0b96ab6d63ab7',
            defaultMessage: 'About the event',
            description: 'Кнопка "подробнее" в спортивном барабане',
        }),
    watch_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.sport.i18n.f20658650d987d31063b593c05980397',
            defaultMessage: 'Watch',
            description: 'Кнопка "смотреть" в спортивном барабане',
        }),
    on_air_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.sport.i18n.930e348dbe18ea803462a1dfd73e18e1',
            defaultMessage: 'Streaming now',
            description: 'Бейдж "В эфире"',
        }),

    completed_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.sport.i18n.8f3d10eb21bd36347c258679eba9e92b',
            defaultMessage: 'Finished',
            description: 'Текст состояния завершенного спортивного события',
        }),
    login_button_text: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.sport.i18n.be11c74c1dd7f307bb80183a90dc2067',
            defaultMessage: 'Get started',
            description: 'Текст кнопки "начать" в спортивном барабане',
        }),
};
